import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../../api";
import { label } from "../../labels";
import { btnPrimary, btnSage, inputCls } from "./ui";

const EMPTY = { firstName: "", lastName: "", level: "", courseId: "" };

export default function StudentsPanel() {
  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);
  const [filter, setFilter] = useState("");
  const [showArchived, setShowArchived] = useState(false);
  const [err, setErr] = useState("");
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const load = () =>
    api
      .get(`/students?status_filter=${showArchived ? "archived" : "active"}`)
      .then(({ data }) => setStudents(data))
      .catch((ex) => setErr(formatApiError(ex)));

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showArchived]);
  useEffect(() => {
    api.get("/courses").then(({ data }) => setCourses(data));
  }, []);

  const create = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/students", { ...form, courseId: form.courseId || null, level: form.level || null });
      setForm(EMPTY);
      setCreating(false);
      load();
    } catch (ex) {
      setErr(formatApiError(ex));
    }
  };

  const filtered = students.filter((s) =>
    `${s.firstName} ${s.lastName} ${s.studentCode} ${s.courseName || ""}`.toLowerCase().includes(filter.toLowerCase())
  );
  const f = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3 flex-wrap">
        <input placeholder="Buscar alumno o curso…" value={filter} onChange={(e) => setFilter(e.target.value)} className={`${inputCls} flex-1 min-w-[200px]`} data-testid="eid-admin-search" />
        <label className="text-[12px] flex items-center gap-2">
          <input type="checkbox" checked={showArchived} onChange={(e) => setShowArchived(e.target.checked)} data-testid="eid-admin-show-archived" />
          Ver archivados
        </label>
        <button onClick={() => setCreating((v) => !v)} className={btnPrimary} data-testid="eid-admin-new-student-btn">
          {creating ? "Cancelar" : "+ Nuevo alumno"}
        </button>
      </div>

      {creating && (
        <form onSubmit={create} className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3 p-4 bg-white rounded-2xl border border-[#132C44]/10" data-testid="eid-admin-new-student-form">
          <input required placeholder="Nombre" value={form.firstName} onChange={f("firstName")} className={inputCls} data-testid="eid-admin-new-firstname" />
          <input required placeholder="Apellido" value={form.lastName} onChange={f("lastName")} className={inputCls} data-testid="eid-admin-new-lastname" />
          <select value={form.courseId} onChange={f("courseId")} className={inputCls} data-testid="eid-admin-new-course">
            <option value="">Sin curso</option>
            {courses.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <input placeholder="Nivel (A1, B1…)" value={form.level} onChange={f("level")} className={inputCls} data-testid="eid-admin-new-level" />
          <button type="submit" className={btnSage} data-testid="eid-admin-new-submit">Crear</button>
        </form>
      )}

      {err && <div className="text-[13px] text-[#9B2C3B]" data-testid="eid-admin-error">{err}</div>}

      <div className="overflow-x-auto rounded-2xl bg-white border border-[#132C44]/10">
        <table className="w-full text-[13px]" data-testid="eid-admin-student-table">
          <thead className="bg-[#132C44]/5 text-left text-[10px] uppercase tracking-widest">
            <tr><th className="p-3">Código</th><th className="p-3">Nombre</th><th className="p-3">Curso</th><th className="p-3">Nivel</th><th className="p-3">Estado</th><th className="p-3" /></tr>
          </thead>
          <tbody>
            {filtered.map((s) => (
              <tr key={s.id} className="border-t border-[#132C44]/5 hover:bg-[#132C44]/[0.02]">
                <td className="p-3 font-mono text-[12px]">{s.studentCode}</td>
                <td className="p-3 font-semibold">{s.firstName} {s.lastName}</td>
                <td className="p-3">{s.courseName || "—"}</td>
                <td className="p-3">{s.level || s.courseLevel || "—"}</td>
                <td className="p-3">{label(s.status)}</td>
                <td className="p-3 text-right">
                  <Link to={`/english-id/admin/students/${s.id}`} className="text-[12px] font-semibold text-[#132C44] hover:underline" data-testid={`eid-admin-open-${s.studentCode}`}>
                    Abrir →
                  </Link>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={6} className="p-6 text-center text-[#132C44]/60">Sin resultados.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
